/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  PostApiUniversignCheckSignerIdentity422,
  PostApiUniversignCheckSignerIdentity502,
  PostApiUniversignCheckSignerIdentity504,
  PostApiUniversignSauvegardeFichier401,
  PostApiUniversignSauvegardeFichier404,
  PostApiUniversignSauvegardeFichier422,
  PostApiUniversignSauvegardeFichier502,
  PostApiUniversignValidationCoordonnees401,
  PostApiUniversignValidationCoordonnees404,
  PostApiUniversignValidationCoordonnees422,
  PostApiUniversignValidationCoordonnees502,
  PostApiUniversignValidationToken401,
  PostApiUniversignValidationToken404,
  PostApiUniversignValidationToken422,
  PostApiUniversignValidationToken502,
  UniversignCheckSignerIdentityRequest,
  UniversignCheckSignerIdentityResponse,
  UniversignSauvegardeFileRequest,
  UniversignSauvegardeFileResponse,
  UniversignValidationCoordonneesRequest,
  UniversignValidationCoordonneesResponse,
  UniversignValidationTokenRequest,
  UniversignValidationTokenResponse,
} from '../placementApi.schemas.ts';

import postApiUniversignCheckSignerIdentityMutator from '.././mutator/placement-instance.ts';
import postApiUniversignSauvegardeFichierMutator from '.././mutator/placement-instance.ts';
import postApiUniversignValidationCoordonneesMutator from '.././mutator/placement-instance.ts';
import postApiUniversignValidationTokenMutator from '.././mutator/placement-instance.ts';

/**
 * Vérifie si l'identité du signataire est déjà connue (certifiée) dans Universign via SEL. Si l'identité est inconnue, un `idSouscription` est retourné pour permettre l'upload des pièces justificatives.
 * @summary Vérifier l'identité d'un signataire Universign
 */
export const postApiUniversignCheckSignerIdentity = (
  universignCheckSignerIdentityRequest: UniversignCheckSignerIdentityRequest,
  signal?: AbortSignal
) => {
  return postApiUniversignCheckSignerIdentityMutator<UniversignCheckSignerIdentityResponse>({
    url: `/api/universign/check-signer-identity`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: universignCheckSignerIdentityRequest,
    signal,
  });
};

export const getPostApiUniversignCheckSignerIdentityMutationKey = () =>
  ['postApiUniversignCheckSignerIdentity'] as const;

export const getPostApiUniversignCheckSignerIdentityMutationOptions = <
  TError =
    | PostApiUniversignCheckSignerIdentity422
    | PostApiUniversignCheckSignerIdentity502
    | PostApiUniversignCheckSignerIdentity504,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUniversignCheckSignerIdentity>>,
    TError,
    PostApiUniversignCheckSignerIdentityMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUniversignCheckSignerIdentity>>,
  TError,
  PostApiUniversignCheckSignerIdentityMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiUniversignCheckSignerIdentityMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUniversignCheckSignerIdentity>>,
    PostApiUniversignCheckSignerIdentityMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postApiUniversignCheckSignerIdentity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUniversignCheckSignerIdentityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUniversignCheckSignerIdentity>>
>;
export type PostApiUniversignCheckSignerIdentityMutationBody = UniversignCheckSignerIdentityRequest;
export type PostApiUniversignCheckSignerIdentityMutationError =
  | PostApiUniversignCheckSignerIdentity422
  | PostApiUniversignCheckSignerIdentity502
  | PostApiUniversignCheckSignerIdentity504;
export type PostApiUniversignCheckSignerIdentityMutationVariables = { data: UniversignCheckSignerIdentityRequest };

/**
 * @summary Vérifier l'identité d'un signataire Universign
 */
export const usePostApiUniversignCheckSignerIdentity = <
  TError =
    | PostApiUniversignCheckSignerIdentity422
    | PostApiUniversignCheckSignerIdentity502
    | PostApiUniversignCheckSignerIdentity504,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUniversignCheckSignerIdentity>>,
      TError,
      PostApiUniversignCheckSignerIdentityMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUniversignCheckSignerIdentity>>,
  TError,
  PostApiUniversignCheckSignerIdentityMutationVariables,
  TContext
> => {
  return useMutation(getPostApiUniversignCheckSignerIdentityMutationOptions(options), queryClient);
};
/**
 * Sauvegarde les fichiers justificatifs (pièce d'identité, origine des fonds) d'une souscription en les transmettant à SEL.
 * @summary Sauvegarder les fichiers justificatifs d'une souscription
 */
export const postApiUniversignSauvegardeFichier = (
  universignSauvegardeFileRequest: UniversignSauvegardeFileRequest,
  signal?: AbortSignal
) => {
  return postApiUniversignSauvegardeFichierMutator<UniversignSauvegardeFileResponse>({
    url: `/api/universign/sauvegarde-fichier`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: universignSauvegardeFileRequest,
    signal,
  });
};

export const getPostApiUniversignSauvegardeFichierMutationKey = () => ['postApiUniversignSauvegardeFichier'] as const;

export const getPostApiUniversignSauvegardeFichierMutationOptions = <
  TError =
    | PostApiUniversignSauvegardeFichier401
    | PostApiUniversignSauvegardeFichier404
    | PostApiUniversignSauvegardeFichier422
    | PostApiUniversignSauvegardeFichier502,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUniversignSauvegardeFichier>>,
    TError,
    PostApiUniversignSauvegardeFichierMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUniversignSauvegardeFichier>>,
  TError,
  PostApiUniversignSauvegardeFichierMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiUniversignSauvegardeFichierMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUniversignSauvegardeFichier>>,
    PostApiUniversignSauvegardeFichierMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postApiUniversignSauvegardeFichier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUniversignSauvegardeFichierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUniversignSauvegardeFichier>>
>;
export type PostApiUniversignSauvegardeFichierMutationBody = UniversignSauvegardeFileRequest;
export type PostApiUniversignSauvegardeFichierMutationError =
  | PostApiUniversignSauvegardeFichier401
  | PostApiUniversignSauvegardeFichier404
  | PostApiUniversignSauvegardeFichier422
  | PostApiUniversignSauvegardeFichier502;
export type PostApiUniversignSauvegardeFichierMutationVariables = { data: UniversignSauvegardeFileRequest };

/**
 * @summary Sauvegarder les fichiers justificatifs d'une souscription
 */
export const usePostApiUniversignSauvegardeFichier = <
  TError =
    | PostApiUniversignSauvegardeFichier401
    | PostApiUniversignSauvegardeFichier404
    | PostApiUniversignSauvegardeFichier422
    | PostApiUniversignSauvegardeFichier502,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUniversignSauvegardeFichier>>,
      TError,
      PostApiUniversignSauvegardeFichierMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUniversignSauvegardeFichier>>,
  TError,
  PostApiUniversignSauvegardeFichierMutationVariables,
  TContext
> => {
  return useMutation(getPostApiUniversignSauvegardeFichierMutationOptions(options), queryClient);
};
/**
 * Valide les coordonnées (email ou téléphone) d'une souscription en les transmettant à SEL. Si un email est fourni, SEL envoie un code de vérification à confirmer via `/api/universign/validation-token` (`emailToCheck = true`). Sinon le téléphone est enregistré comme numéro Universign.
 * @summary Valider les coordonnées d'une souscription
 */
export const postApiUniversignValidationCoordonnees = (
  universignValidationCoordonneesRequest: UniversignValidationCoordonneesRequest,
  signal?: AbortSignal
) => {
  return postApiUniversignValidationCoordonneesMutator<UniversignValidationCoordonneesResponse>({
    url: `/api/universign/validation-coordonnees`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: universignValidationCoordonneesRequest,
    signal,
  });
};

export const getPostApiUniversignValidationCoordonneesMutationKey = () =>
  ['postApiUniversignValidationCoordonnees'] as const;

export const getPostApiUniversignValidationCoordonneesMutationOptions = <
  TError =
    | PostApiUniversignValidationCoordonnees401
    | PostApiUniversignValidationCoordonnees404
    | PostApiUniversignValidationCoordonnees422
    | PostApiUniversignValidationCoordonnees502,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUniversignValidationCoordonnees>>,
    TError,
    PostApiUniversignValidationCoordonneesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUniversignValidationCoordonnees>>,
  TError,
  PostApiUniversignValidationCoordonneesMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiUniversignValidationCoordonneesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUniversignValidationCoordonnees>>,
    PostApiUniversignValidationCoordonneesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postApiUniversignValidationCoordonnees(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUniversignValidationCoordonneesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUniversignValidationCoordonnees>>
>;
export type PostApiUniversignValidationCoordonneesMutationBody = UniversignValidationCoordonneesRequest;
export type PostApiUniversignValidationCoordonneesMutationError =
  | PostApiUniversignValidationCoordonnees401
  | PostApiUniversignValidationCoordonnees404
  | PostApiUniversignValidationCoordonnees422
  | PostApiUniversignValidationCoordonnees502;
export type PostApiUniversignValidationCoordonneesMutationVariables = { data: UniversignValidationCoordonneesRequest };

/**
 * @summary Valider les coordonnées d'une souscription
 */
export const usePostApiUniversignValidationCoordonnees = <
  TError =
    | PostApiUniversignValidationCoordonnees401
    | PostApiUniversignValidationCoordonnees404
    | PostApiUniversignValidationCoordonnees422
    | PostApiUniversignValidationCoordonnees502,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUniversignValidationCoordonnees>>,
      TError,
      PostApiUniversignValidationCoordonneesMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUniversignValidationCoordonnees>>,
  TError,
  PostApiUniversignValidationCoordonneesMutationVariables,
  TContext
> => {
  return useMutation(getPostApiUniversignValidationCoordonneesMutationOptions(options), queryClient);
};
/**
 * Valide le code de vérification reçu par email lors de l'appel à `/api/universign/validation-coordonnees`, en le transmettant à SEL. Le code expire au bout de 10 minutes : `valide = false` couvre à la fois un code faux, expiré ou introuvable.
 * @summary Valider le code de vérification d'une adresse mail
 */
export const postApiUniversignValidationToken = (
  universignValidationTokenRequest: UniversignValidationTokenRequest,
  signal?: AbortSignal
) => {
  return postApiUniversignValidationTokenMutator<UniversignValidationTokenResponse>({
    url: `/api/universign/validation-token`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: universignValidationTokenRequest,
    signal,
  });
};

export const getPostApiUniversignValidationTokenMutationKey = () => ['postApiUniversignValidationToken'] as const;

export const getPostApiUniversignValidationTokenMutationOptions = <
  TError =
    | PostApiUniversignValidationToken401
    | PostApiUniversignValidationToken404
    | PostApiUniversignValidationToken422
    | PostApiUniversignValidationToken502,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUniversignValidationToken>>,
    TError,
    PostApiUniversignValidationTokenMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUniversignValidationToken>>,
  TError,
  PostApiUniversignValidationTokenMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiUniversignValidationTokenMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUniversignValidationToken>>,
    PostApiUniversignValidationTokenMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postApiUniversignValidationToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUniversignValidationTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUniversignValidationToken>>
>;
export type PostApiUniversignValidationTokenMutationBody = UniversignValidationTokenRequest;
export type PostApiUniversignValidationTokenMutationError =
  | PostApiUniversignValidationToken401
  | PostApiUniversignValidationToken404
  | PostApiUniversignValidationToken422
  | PostApiUniversignValidationToken502;
export type PostApiUniversignValidationTokenMutationVariables = { data: UniversignValidationTokenRequest };

/**
 * @summary Valider le code de vérification d'une adresse mail
 */
export const usePostApiUniversignValidationToken = <
  TError =
    | PostApiUniversignValidationToken401
    | PostApiUniversignValidationToken404
    | PostApiUniversignValidationToken422
    | PostApiUniversignValidationToken502,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUniversignValidationToken>>,
      TError,
      PostApiUniversignValidationTokenMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUniversignValidationToken>>,
  TError,
  PostApiUniversignValidationTokenMutationVariables,
  TContext
> => {
  return useMutation(getPostApiUniversignValidationTokenMutationOptions(options), queryClient);
};
